import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { FaStar } from "react-icons/fa";

const FeaturedProducts = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchFeaturedProducts = async () => {
      try {
        const response = await fetch(
          "https://tyka.premierhostings.com/backend/api/site-banner"
        );
        const data = await response.json();
        console.log("✅ Featured Products API Response:", data);

        if (data?.featured_products?.data) {
          setProducts(data.featured_products.data);
        }
      } catch (error) {
        console.error("❌ Error fetching featured products:", error);
      }
    };

    fetchFeaturedProducts();
  }, []);

  return (
    <>
      <section className="py-12 px-4 max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex justify-between items-start mb-8 flex-wrap gap-4">
          <h2 className="text-2xl font-bold text-black">Featured Products</h2>
          <p className="text-sm text-gray-500 max-w-md">
            Defy your limits on and off the field in our classic featured gear
            designed both for performance and style.
          </p>
        </div>

        {/* Carousel with external navigation */}
        <div className="relative flex items-center mb-12">
          <button className="swiper-button-prev-custom hidden lg:block absolute -left-8 top-[36%] z-10 text-black text-3xl">
            &#10094;
          </button>

          <Swiper
            modules={[Navigation, Pagination]}
            navigation={{
              nextEl: ".swiper-button-next-custom",
              prevEl: ".swiper-button-prev-custom",
            }}
            pagination={{ clickable: true }}
            spaceBetween={20}
            breakpoints={{
              0: { slidesPerView: 1 },
              480: { slidesPerView: 2 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            style={{ paddingBottom: "40px" }}
          >
            {products.map((product, index) => (
              <SwiperSlide key={index} style={{ width: "400px" }}>
                <div className="bg-white relative group">
                  {product.is_sale && (
                    <span className="absolute top-3 left-3 bg-green-100 text-[10px] font-bold text-black px-2 py-1 rounded uppercase z-10">
                      SALE
                    </span>
                  )}
                  {/* Image wrapped in link */}
                  <a href={`/${product.slug}`}>
                    <img
                      src={
                        product.default_image?.length > 0
                          ? `${product.default_image}`
                          : "/images/placeholder.png"
                      }
                      alt={product.name}
                      className="w-full h-[600px] object-cover"
                    />
                  </a>
                  <div className="p-4 bg-white">
                    <p className="text-gray-500 mt-1 flex items-center gap-1 ml-[-15px] ">
                      {Array.from({ length: 5 }).map((_, starIdx) => (
                        <FaStar
                          key={starIdx}
                          className={`${
                            starIdx < Math.round(product?.star || 0)
                              ? "text-yellow-400"
                              : "text-gray-300"
                          }`}
                        />
                      ))}
                    </p>
                    <h3
                      className="text-sm font-semibold mb-1 text-black hover:text-blue-600 cursor-pointer capitalize "
                      style={{ marginLeft: "-15px" }}
                    >
                      {product.name}
                    </h3>
                    <div className="text-sm" style={{ marginLeft: "-15px" }}>
                      {product.price &&
                        product.price !== product.selling_price && (
                          <span className="line-through text-gray-400 mr-2">
                            ₹{product.price}
                          </span>
                        )}
                      <span className="font-bold text-black">
                        ₹{product.selling_price}
                      </span>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <button className="swiper-button-next-custom hidden lg:block absolute -right-6 top-[36%] z-10 text-black text-3xl">
            &#10095;
          </button>
        </div>
      </section>

      {/* Video Container */}
      <div className="w-full">
        <div className="w-full aspect-w-16 aspect-h-9 overflow-hidden shadow-lg">
          <video
            className="w-full h-full object-cover"
            controls
            autoPlay
            muted
            loop
            controlsList="nodownload"
          >
            <source src="/video/roller.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </>
  );
};

export default FeaturedProducts;
